/*============================================================================
  Collapsible for sidebar filters
==============================================================================*/
var coll = document.getElementsByClassName("collection-filters-button");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = 0;
    } 
  });
}

/*============================================================================
  Scroll To Top Button
==============================================================================*/
var btn = $('#to-top-button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

/*============================================================================
  Active Buttons for images on Product Page
==============================================================================*/
// Add active class to the current button (highlight it)
var header = document.getElementById("productThumbs-product-template");
var thumbs = header.getElementsByClassName("product-photo-thumb");
for (var i = 0; i < thumbs.length; i++) {
    thumbs[i].addEventListener("click", function() {
        var current = document.getElementsByClassName("activeThumb");
        current[0].className = current[0].className.replace(" activeThumb", "");
        this.className += " activeThumb";
    });
}

/*============================================================================
  Active Buttons for Gym COVID19 Informations
==============================================================================*/
// function openTabbed(evt, tabbedName) {
//   // Declare all variables
//   var i, tabcontent, tablinks;

//   // Get all elements with class="tabcontent" and hide them
//   tabcontent = document.getElementsByClassName("tabcontent");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }

//   // Get all elements with class="tablinks" and remove the class "active"
//   tablinks = document.getElementsByClassName("tablinks");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }

//   // Show the current tab, and add an "active" class to the button that opened the tab
//   document.getElementById(tabbedName).style.display = "block";
//   evt.currentTarget.className += " active";
// }

// // Get the element with id="defaultOpen" and click on it
// document.getElementById("defaultOpen").click

function openTabbed(evt, tabbedName) {
  var i, x, tablinks;
  x = document.getElementsByClassName("gym-tabcontent");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < x.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabbedName).style.display = "block";
  evt.currentTarget.className += " active";
}